"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8680],{

/***/ 28680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export boardNameMap */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _components_esg_guide_EsgSearchFilter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87203);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30202);
/* harmony import */ var _common_queryKeys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51586);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  > ul {\n    @media (max-width: 991px) {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      grid-column-gap: 10px;\n      grid-row-gap: 10px;\n      .submenu {\n        display: none;\n      }\n    }\n    @media (max-width: 399px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  & a {\n    word-break: keep-all;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    @media (max-width: 1200px) {\n      padding: 15px 10px !important;\n    }\n    @media (max-width: 991px) {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 0 0 20px;\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  & span {\n    margin-bottom: 10px;\n    border-bottom: 1px solid #ececec;\n    cursor: pointer;\n    :last-of-type {\n      margin-bottom: 0;\n    }\n  }\n  .activeSub {\n    color: #3bb77e;\n  }\n  .noneSub {\n    color: #7e7e7e;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  @media (max-width: 991px) {\n    flex-wrap: wrap;\n    .dashboard-menu {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var MenuWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f01aea2e-0"
})(_templateObject());
var Menu = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-f01aea2e-1"
})(_templateObject1());
var SubMenu = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f01aea2e-2"
})(_templateObject2());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f01aea2e-3"
})(_templateObject3());
var pathName = [
    "",
    "certification",
    "news",
    "letter",
    "blog/package",
    "blog/make", 
];
var sideMenus = [
    "ESG",
    "\uD3EC\uC7A5\uC7AC \uC778\uC99D\uC815\uBCF4",
    "ESG \uD658\uACBD\uB274\uC2A4",
    "ESG \uB274\uC2A4\uB808\uD130",
    "\uC18C\uC7AC\uC640 \uD3EC\uC7A5\uC7AC",
    "\uC81C\uC791\uC0AC\uB840 & \uD3EC\uC7A5\uC7AC\uB9AC\uBDF0", 
];
var boardNameMap = {
    1: "certification",
    2: "news",
    3: "letter",
    4: "package",
    5: "make"
};
var EsgLayout = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useQueryClient */ .NL)();
    var routePathName = router.pathname.split("esg-guide/")[1];
    var activeIndex = pathName.indexOf(routePathName ? routePathName : router.pathname.split("/")[0]);
    // 공통 검색 상태 관리
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        searchTerm: "",
        page: 1
    }), searchParams = ref[0], setSearchParams = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), page = ref1[0], setPage = ref1[1];
    var pageRows = 10;
    // 현재 활성화된 메뉴에 해당하는 boardName 가져오기
    var getCurrentBoardName = function() {
        return boardNameMap[activeIndex] || "";
    };
    // 페이지 변경 처리
    var handlePageChange = function(newPage) {
        setPage(newPage);
        setSearchParams(function(prev) {
            return _objectSpread({}, prev, {
                page: newPage
            });
        });
        window.scrollTo(0, 100);
        // 쿼리 무효화 처리
        var boardName = getCurrentBoardName();
        if (boardName) {
            queryClient.invalidateQueries({
                queryKey: _common_queryKeys__WEBPACK_IMPORTED_MODULE_4__/* .QUERY_KEYS.ESG.BOARDS.INDEX */ .U.ESG.BOARDS.INDEX(boardName, searchParams.searchTerm, newPage, pageRows)
            });
        }
    };
    // 검색 처리 로직 - 자식 컴포넌트에 전달
    var handleSearch = function(term) {
        setSearchParams({
            searchTerm: term,
            page: 1
        });
        setPage(1);
        // 쿼리 무효화 처리
        var boardName = getCurrentBoardName();
        if (boardName) {
            queryClient.invalidateQueries({
                queryKey: _common_queryKeys__WEBPACK_IMPORTED_MODULE_4__/* .QUERY_KEYS.ESG.BOARDS.INDEX */ .U.ESG.BOARDS.INDEX(boardName, term, 1, pageRows)
            });
        }
    };
    var handleOnClick = function(index) {
        var url = "/esg-guide/".concat(pathName[index]);
        router.push(url);
        // 메뉴 변경 시 검색 상태 초기화
        setSearchParams({
            searchTerm: "",
            page: 1
        });
        setPage(1);
    };
    // 자식 컴포넌트에 전달할 공통 props
    var commonChildProps = {
        searchParams: searchParams,
        setSearchParams: setSearchParams,
        page: page,
        pageRows: pageRows,
        boardName: getCurrentBoardName(),
        onPageChange: handlePageChange,
        onSearch: handleSearch
    };
    // 자식 요소에 props 전달
    var childrenWithProps = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(props.children, function(child) {
        // 리액트 요소인지 확인
        if (/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.isValidElement(child)) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(child, commonChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "page-content mt-50",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-lg-12 m-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
                        className: "row",
                        children: [
                            activeIndex !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-md-2 mb-30 dashboard-menu",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuWrapper, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                        className: "nav flex-column",
                                        role: "tablist",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Menu, {
                                                className: "nav-item",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: activeIndex === 0 ? "nav-link active" : "nav-link",
                                                    onClick: function() {
                                                        return handleOnClick(0);
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "fi-rs-hand-holding-heart mr-10",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "font-sm",
                                                                children: sideMenus[0]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Menu, {
                                                className: "nav-item",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: activeIndex === 1 ? "nav-link active" : "nav-link",
                                                    onClick: function() {
                                                        return handleOnClick(1);
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "fi-rs-asterik mr-10",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "font-sm",
                                                                children: sideMenus[1]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Menu, {
                                                className: "nav-item",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: activeIndex === 2 ? "nav-link active" : "nav-link",
                                                    onClick: function() {
                                                        return handleOnClick(2);
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "fi-rs-ballot mr-10",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "font-sm",
                                                                children: sideMenus[2]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Menu, {
                                                className: "nav-item menu-item-has-children",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: activeIndex === 3 ? "nav-link active" : "nav-link",
                                                    onClick: function() {
                                                        return handleOnClick(3);
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "fi-rs-blog-text mr-10",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "font-sm",
                                                                children: sideMenus[3]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Menu, {
                                                className: "nav-item menu-item-has-children",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: activeIndex === 4 ? "nav-link active" : "nav-link",
                                                    onClick: function() {
                                                        return handleOnClick(4);
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "fi-rs-bold mr-10",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "font-sm",
                                                                children: sideMenus[4]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Menu, {
                                                className: "nav-item menu-item-has-children",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: activeIndex === 5 ? "nav-link active" : "nav-link",
                                                    onClick: function() {
                                                        return handleOnClick(5);
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "fi-rs-bold mr-10",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "font-sm",
                                                                children: sideMenus[5]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            activeIndex !== 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "col-lg-10 pl-sm-30",
                                style: {
                                    minHeight: "30rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mb-30 d-flex align-items-center flex-wrap",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                style: {
                                                    margin: 0,
                                                    whiteSpace: "nowrap"
                                                },
                                                children: sideMenus[activeIndex]
                                            }),
                                            activeIndex !== 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex-grow-1",
                                                style: {
                                                    minWidth: "280px"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_esg_guide_EsgSearchFilter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    searchParams: searchParams,
                                                    setSearchParams: setSearchParams,
                                                    boardName: getCurrentBoardName(),
                                                    page: page,
                                                    pageRow: pageRows,
                                                    onPageChange: handlePageChange
                                                })
                                            })
                                        ]
                                    }),
                                    childrenWithProps
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: childrenWithProps
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EsgLayout);


/***/ }),

/***/ 87203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n\n  @media (max-width: 991px) {\n    display: flex;\n    width: 100%;\n  }\n  @media (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n\n  @media (max-width: 767px) {\n    display: flex;\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: 300px;\n\n  @media (max-width: 767px) {\n    max-width: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 40px;\n  padding: 0 40px 0 12px;\n  font-size: 14px;\n  border: 1px solid #3bb77e;\n  border-radius: 8px;\n  outline: none;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #3bb77e;\n  background: transparent;\n  border: none;\n  padding: 0;\n\n  i {\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var SizeFilterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd6456cd-0"
})(_templateObject());
var MobileSizeFilterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd6456cd-1"
})(_templateObject1());
var InputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd6456cd-2"
})(_templateObject2());
var SizeInput = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-dd6456cd-3"
})(_templateObject3());
var SearchButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-dd6456cd-4"
})(_templateObject4());
var EsgSearchFilter = function(param) {
    var searchParams = param.searchParams, setSearchParams = param.setSearchParams, onPageChange = param.onPageChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), searchTerm = ref[0], setSearchTerm = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (searchParams === null || searchParams === void 0 ? void 0 : searchParams.searchTerm) {
            setSearchTerm(searchParams.searchTerm);
        } else {
            setSearchTerm("");
        }
    }, [
        searchParams
    ]);
    var handleFilter = function() {
        setSearchParams(function(prev) {
            return _objectSpread({}, prev, {
                searchTerm: searchTerm,
                page: 1
            });
        });
        if (onPageChange) {
            onPageChange(1);
        }
    };
    var handleInputChange = function(e) {
        setSearchTerm(e.target.value);
    };
    var handleKeyDown = function(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            handleFilter();
        }
    };
    var renderSearchBox = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                    onChange: handleInputChange,
                    placeholder: "\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD558\uC138\uC694",
                    value: searchTerm,
                    onKeyDown: handleKeyDown,
                    "aria-label": "\uAC80\uC0C9\uC5B4 \uC785\uB825"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchButton, {
                    onClick: handleFilter,
                    "aria-label": "\uAC80\uC0C9",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fi-rs-search",
                        "aria-hidden": "true"
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeFilterWrapper, {
                children: renderSearchBox()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileSizeFilterWrapper, {
                children: renderSearchBox()
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EsgSearchFilter);


/***/ })

}]);